import React from 'react';
import shoppingCart from '../../utils/shoppingCart';
import Button from '../common/Button';

const SendEmailButton = props => {
  const sendMail = () => {
    var subject = `Pedido ${props.store}`;
    var body = `Hola ${
      props.store
    }, quería hacer un pedido de las siguientes cartas:
${props.cards
  .map(card => {
    return (
      card.name +
      ' - ' +
      card.cardPrices[0].edition +
      ' - ' +
      card.cardPrices[0].condition +
      ' - ' +
      card.cardPrices[0].language +
      ': $ ' +
      card.cardPrices[0].price
    );
  })
  .join('\n')}
Total: ${props.totalAmount} ${props.cards[0].cardPrices[0].currency}`;
    var uri = `mailto:${shoppingCart.getStore(props.store).email}?subject=`;
    uri += encodeURIComponent(subject);
    uri += '&body=';
    uri += encodeURIComponent(body);
    window.open(uri);
  };

  return (
    <Button className="w-32" iconClass="fas fa-mail" onClick={() => sendMail()}>
      Enviar email
    </Button>
  );
};

export default SendEmailButton;
